import { compose, withPropsOnChange, defaultProps } from 'recompose'
import get from 'lodash/get'
import { createWithLazyEntity } from 'components/LazyFetch'
import {
  EQUIPMENTS_SCHEMA_NAME,
  equipmentsSelector,
  equipmentsEntitiesSelector,
  equipmentsApiActions,
} from 'api/equipments'

export const equipmentDataPropName = `equipment`

export const withEquipment = createWithLazyEntity({
  entitiesSelector: equipmentsEntitiesSelector,
  dataSelector    : equipmentsSelector,
  schemaName      : EQUIPMENTS_SCHEMA_NAME,
  fetchApiAction  : equipmentsApiActions.getEquipmentByCode,
  dataPropName    : equipmentDataPropName,
})

const defaultExtractText = (equipment) => get(equipment, `info`)

const enhancer = compose(
  defaultProps({
    extractText: defaultExtractText,
  }),
  withPropsOnChange([`value`, `data`], ({ data, value }) => {
    const entityId = data || value

    return {
      entityId,
      errorComponent: () => entityId || `Нет данных`,
    }
  }),
  withEquipment,
)

const EquipmentFormatterFormatter = ({
  equipment,
  extractText,
}) => (
  extractText(equipment) || `Нет данных`
)

export default enhancer(EquipmentFormatterFormatter)
